import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import OrderList from "@/components/lists/order.vue"
  import OrderToolbar from "@/components/toolbars/order.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Order,
    OrderEnumerationResponse,
    OrderInput,
    OrderResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Order as OrderResolver} from "@/endpoints/rutsolve/gql/resolvers/order"
  import {Enumeration as EnumerationResolver} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import {PurchaseOrderSelector as Storage} from "@/storage/purchase_order_selector"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'purchase_order',
  props: {
    "value": {
    default: null,
    required: false,
    type: Object as PropType<Order>
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels([
    "select",
  ], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const value = _useModel(__props, "value")

  const emits = __emit

  const error = ref<Error>(null)
  const orderResolver = new OrderResolver()
  const enumerationResolver = new EnumerationResolver()
  const orderResponse = ref<OrderResponse>(null)
  const orderEnumerationResponse = ref<OrderEnumerationResponse>(null)
  const orderInput = ref<OrderInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeInput(orderInput.value)
    read()
  }

  async function select() {
    const selectedOrder = orderResponse.value.records[selectedIndex.value]
    value.value = selectedOrder
    Storage.writeOrderID(selectedOrder.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteInput()
    Storage.deleteOrderID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      orderEnumerationResponse.value = await enumerationResolver.readOrderEnumerations()
      const storedOrderInput = Storage.readInput()
      orderInput.value = structuredClone(storedOrderInput)
      orderResponse.value = await orderResolver.selector(storedOrderInput)
      if (!orderResponse.value || !orderResponse.value.records) {
        return
      }
      const storedSelectedOrderID = Storage.readOrderID()
      for (const [index, order] of orderResponse.value.records.entries()) {
        if (order.id == storedSelectedOrderID) {
          selectedIndex.value = index
          value.value = order
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (orderEnumerationResponse.value)
        ? (_openBlock(), _createBlock(OrderToolbar, {
            key: 0,
            value: orderInput.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((orderInput).value = $event)),
            orderOrders: orderEnumerationResponse.value.orders,
            orderStatuses: orderEnumerationResponse.value.statuses,
            orderTypes: ['PURCHASE_CREDIT', 'PURCHASE_DEBIT', 'PURCHASE_OFFER'],
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (update())),
            onReset: _cache[2] || (_cache[2] = ($event: any) => (reset()))
          }, null, 8, ["value", "orderOrders", "orderStatuses"]))
        : _createCommentVNode("", true),
      (orderResponse.value)
        ? (_openBlock(), _createBlock(OrderList, {
            key: 1,
            selectedIndex: selectedIndex.value,
            "onUpdate:selectedIndex": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            items: orderResponse.value.records,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (select()))
          }, null, 8, ["selectedIndex", "items"]))
        : _createCommentVNode("", true),
      (orderResponse.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 2,
            currentPage: orderInput.value.plot.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((orderInput.value.plot.page) = $event)),
            itemTotal: orderResponse.value.recordsTotal,
            pageItems: orderInput.value.plot.items,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, null, 8, ["currentPage", "itemTotal", "pageItems"]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 3,
            error: error.value,
            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})